module.exports = __webpack_public_path__ + "TB_Warning_SFX_A.wav.4991e452.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/warning/TB_Warning_SFX_A.wav.mp3
// module id = 512
// module chunks = 0